import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { CreateMassRerateModel } from '@shared/models/create-mass-rerate.model';
import { MrraGridFiltersModel } from '@shared/models/mrra-grid-filters.model';
import { MrraListModel, MrraStatusCountModel } from '@shared/models/mrra-list.model';
import { MrraTraySummaryModel } from '@shared/models/mrra-tray-summary.model';
import { CreateAdhocMassRerateResp } from '@xpo-ltl-2.0/sdk-rating';
import { MrraActions } from '../actions/mrra.actions';

export const mrraFeatureKey = 'mrra';
export const mrraFeatureSelector = createFeatureSelector<MrraState>(mrraFeatureKey);

export interface MrraState {
  createdMassRerate: CreateAdhocMassRerateResp;
  mrraList: MrraListModel;
  createdNewMassRerate: CreateMassRerateModel;
  gridFilters: MrraGridFiltersModel;
  whatIfRequestData: MrraTraySummaryModel;
  mrraStatusCounts: MrraStatusCountModel[];
  loadingGetAccounts: boolean;
  loadingGetAccountsOverride: boolean;
}

export const mrraInitialState: MrraState = {
  createdMassRerate: undefined,
  mrraList: undefined,
  createdNewMassRerate: undefined,
  gridFilters: undefined,
  whatIfRequestData: undefined,
  mrraStatusCounts: undefined,
  loadingGetAccounts: false,
  loadingGetAccountsOverride: false,
};

export const reducer = createReducer(
  mrraInitialState,
  on(MrraActions.clearMrraStore, (state) => {
    return {
      ...mrraInitialState,
    };
  }),
  on(MrraActions.createMassRerate, (state) => {
    return {
      ...state,
      createdMassRerate: undefined
    };
  }),
  on(MrraActions.createMassRerateSuccess, (state, { createMassRerateResp}) => {
    return {
      ...state,
      createdMassRerate: createMassRerateResp,
    };
  }),
  on(MrraActions.listMassRerate, (state) => {
    return {
      ...state,
      mrraList: undefined
    };
  }),
  on(MrraActions.listMassRerateSuccess, (state, { mrraList }) => {
    return {
      ...state,
      mrraList,
    };
  }),
  on(MrraActions.createNewMassRerateRequest, (state) => {
    return {
      ...state,
      createdNewMassRerate: undefined
    };
  }),
  on(MrraActions.createNewMassRerateRequestSuccess, (state, { createdNewMassRerate }) => {
    return {
      ...state,
      createdNewMassRerate,
    };
  }),
  on(MrraActions.setGridFilters, (state, { filters }) => {
    return {
      ...state,
      gridFilters: filters,
    };
  }),
  on(MrraActions.setWhatIfRequestActions, (state, { whatIfRequestData }) => {
    return {
      ...state,
      whatIfRequestData,
    };
  }),
  on(MrraActions.setStatusCountsActions, (state, { mrraStatusCounts }) => {
    return {
      ...state,
      mrraStatusCounts,
    };
  }),
  on(MrraActions.mrraGetAccountsFiltered, (state) => {
    return {
      ...state,
      loadingGetAccounts: true,
    };
  }),
  on(MrraActions.mrraGetAccountsFilteredSuccess, MrraActions.mrraGetAccountsFilteredFail, (state) => {
    return {
      ...state,
      loadingGetAccounts: false,
    };
  }),
  on(MrraActions.mrraGetAccountsOverrideFiltered, (state) => {
    return {
      ...state,
      loadingGetAccountsOverride: true,
    };
  }),
  on(
    MrraActions.mrraGetAccountsOverrideFilteredSuccess,
    MrraActions.mrraGetAccountsOverrideFilteredFail,
    (state) => {
      return {
        ...state,
        loadingGetAccountsOverride: false,
      };
    }
  )
);
